import React, { useEffect, useState } from 'react'
import Error from 'shared/components/Error'
import { withTranslation } from 'react-i18next'
import { addToGoogleDataLayer } from 'shared/const/utls.js'
import UpdateMailingAddressQuestionView from './components/UpdateMailingAddressQuestionView'

const ScreeningQuestion = ({ i18n }) => {
  const [isError, setIsError] = useState(false)

  useEffect(() => {
    try {
      addToGoogleDataLayer('update-mailing-address-question', 'Pay a Debt', i18n.language)
      window.scrollTo(0, 0)
    } catch (e) {
      console.log(e)
    }
  }, [i18n.language])

  return isError ? <Error /> : <UpdateMailingAddressQuestionView setIsError={setIsError} />
}

export default withTranslation('common')(ScreeningQuestion)
